import { pipe } from "fp-ts/lib/function";
import debounce from "lodash/debounce";
import { useCallback, useState } from "react";
import { match } from "ts-pattern";
import { SortOperator } from "@biggeo/bg-server-lib/studio";
import { ColFilterType, Direction, FilterType, Range, WhereOperator, } from "./type";
export const matchFilter = (value, match) => {
    switch (value._type) {
        case ColFilterType.boolean:
            return match[ColFilterType.boolean](value);
        case ColFilterType.multiSelect:
            return match[ColFilterType.multiSelect](value);
        case ColFilterType.date:
            return match[ColFilterType.date](value);
        case ColFilterType.number:
            return match[ColFilterType.number](value);
        default:
            return match[ColFilterType.string](value);
    }
};
const stringOperators = [
    WhereOperator.contains,
    WhereOperator.endsWith,
    WhereOperator.equals,
    WhereOperator.startsWith,
    // WhereOperator.isEmpty,
    // WhereOperator.isNotEmpty,
];
const numberOperators = [
    WhereOperator.eq,
    WhereOperator.gt,
    WhereOperator.gte,
    WhereOperator.lt,
    WhereOperator.lte,
    WhereOperator.neq,
    // WhereOperator.isEmpty,
    // WhereOperator.isNotEmpty,
];
const booleanOperators = [WhereOperator.is];
export const matchOperation = (columnType) => {
    switch (columnType) {
        case ColFilterType.boolean:
            return {
                _type: ColFilterType.boolean,
                operationType: booleanOperators,
                operation: WhereOperator.is,
                data: true,
            };
        case ColFilterType.multiSelect:
            return {
                _type: ColFilterType.multiSelect,
                operationType: booleanOperators,
                operation: WhereOperator.is,
                data: [],
            };
        case ColFilterType.date:
            return {
                _type: ColFilterType.date,
                operationType: booleanOperators,
                operation: WhereOperator.is,
                data: {
                    date: new Date(),
                    direction: Direction.this,
                    range: Range.week,
                },
            };
        case ColFilterType.number:
            return {
                _type: ColFilterType.number,
                operationType: numberOperators,
                operation: WhereOperator.gt,
                data: 0,
            };
        default:
            return {
                _type: ColFilterType.string,
                operationType: stringOperators,
                operation: WhereOperator.contains,
                data: "",
            };
    }
};
export const matchOnchange = (key, input, f, onChange) => {
    matchFilter(f, {
        boolean: (f) => {
            onChange(Object.assign(Object.assign({}, f), { [key]: input }));
        },
        number: (f) => {
            onChange(Object.assign(Object.assign({}, f), { [key]: input }));
        },
        string: (f) => {
            onChange(Object.assign(Object.assign({}, f), { [key]: input }));
        },
        multiSelect: (f) => {
            onChange(Object.assign(Object.assign({}, f), { [key]: input }));
        },
        date: (f) => {
            onChange(Object.assign(Object.assign({}, f), { [key]: input }));
        },
    });
};
export const convertDataType = (input) => {
    return match(input)
        .with("number", () => ColFilterType.number)
        .with("boolean", () => ColFilterType.boolean)
        .with("date", () => ColFilterType.date)
        .with("multiSelect", () => ColFilterType.multiSelect)
        .otherwise(() => ColFilterType.string);
};
export const convertOperationText = (content) => {
    if (content === "eq")
        return "equal";
    return content
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .toLowerCase()
        .replace("neq", "not equal")
        .replace("lte", "less than or equal")
        .replace("lt", "less than")
        .replace("gte", "great than or equal")
        .replace("gt", "great than");
};
export const convertFilterItem = (input) => {
    const f = input.filterItem;
    const column = input.columnName;
    return matchFilter(f, {
        boolean: (f) => ({
            column,
            data: {
                booleanData: f.data,
            },
            operator: f.operation,
            type: FilterType.BooleanType,
        }),
        number: (f) => ({
            column,
            data: {
                numberData: f.data,
            },
            operator: f.operation,
            type: FilterType.NumberType,
        }),
        string: (f) => ({
            column,
            data: {
                stringData: f.data,
            },
            operator: f.operation,
            type: FilterType.StringType,
        }),
        multiSelect: (f) => ({
            column,
            data: {},
            operator: f.operation,
            type: FilterType.StringType,
        }),
        date: (f) => ({
            column,
            data: { dateData: new Date() },
            operator: f.operation,
            type: FilterType.DateType,
        }),
    });
};
export const useDebouncedSearch = (time) => {
    return useCallback(debounce((fn, query) => pipe(query, fn), time || 300), []);
};
export const useDataGridOptions = (limit, tableId) => {
    const pageLimit = limit || 20;
    const [searchText, setSearchText] = useState();
    const [sortModel, setSortModel] = useState([
        {
            field: tableId || "createdAt",
            sort: "asc",
        },
    ]);
    const [filterObject, setFilterObject] = useState();
    const [pageIndex, setPageIndex] = useState(1);
    const resetAll = () => {
        setSearchText(undefined);
        setFilterObject(undefined);
        setPageIndex(1);
    };
    return {
        dataGridFetchInputProps: {
            pageLimit,
            pageIndex,
            searchText,
            filterObject,
            sortModel,
        },
        filterSearchPaginateProps: {
            pageLimit,
            pageIndex,
            setPageIndex,
            searchText,
            setSearchText,
            filterObject,
            setFilterObject,
            resetAll,
            onSortModelChange: (newSortModel) => newSortModel.length > 0 && setSortModel(newSortModel),
            sortModel: sortModel.map((sm) => ({
                field: sm.field,
                sort: sm.sort === "asc"
                    ? SortOperator.asc
                    : SortOperator.desc,
            })),
        },
    };
};
//# sourceMappingURL=utils.js.map